import { formatDistanceToNow, isValid } from 'date-fns'
import locale from 'date-fns/locale/ja'

export const GetDisplayDatetime = (stringDatetime: string) => {
  const datetime = new Date(stringDatetime)

  return isValid(datetime) ? `${formatDistanceToNow(datetime, { locale, addSuffix: true })}` : '不明'
}
